import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import { CBadge } from "@coreui/react-pro";
import AuthService from "./modules/auth/redux/AuthService";
import { GET_ACTIVITIES } from "src/setup/apollo/queries";
import { useApolloClient } from "@apollo/client";

export const AppSidebarNav = ({ items }) => {
  const [isShow, setIsShow] = useState(false);
  const [newItems, setNewItems] = useState([]);
  const role = AuthService.GetCurrentUser()?.userData.roles;
  const salesPersonGuid = AuthService.GetCurrentUser().salesPersonGuid;
  const client = useApolloClient();
  const _activityTypeGuid = "07EF8AFD-4944-4DB0-9773-E9A0A0CBD9CB";
  let usr = {
    role: role,
  };

  console.log("first", newItems);

  let newArray = [];
  //will set
  // will createSalesperson
  const _loadDataAtCursor = async (cursor) => {
    try {
      return await client.query({
        query: GET_ACTIVITIES,
        variables: {
          cursor,
          salesPersonGuid: salesPersonGuid,
          activityTypeGuid: _activityTypeGuid,
        },
      });
    } catch (e) {}
  };
  async function loadActivities() {
    var cursor = undefined;
    var buffer = [];
    async function query() {
      let result = await _loadDataAtCursor(cursor);
      if (result.error) {
        return false;
      }
      const pi = result.data?.activities?.pageInfo;
      if (!pi) return false;
      let activities = result.data.activities.edges.map((r) => r.node);
      buffer.push(...activities);
      cursor = pi.endCursor;
      return pi.hasNextPage;
    }
    var hasMore = true;
    while (hasMore === true) {
      hasMore = await query();
    }

    buffer.map((element) =>
      element.childActivities.map((el) => {
        el.activityStatus.guid == "9abd0bb9-3c89-432f-bad7-532666dcfaa5" &&
          newArray.push(element);
      })
    );

    if (newArray.length != 0) {
      setIsShow(true);
    } else {
      setIsShow(false);
    }
  }

  /* const kurum = role.includes("Kurum");
  const teamLeader = role.includes("TB");
  const editor = role.includes("Editor");
  const consistency = role.includes("TKK");
  const spelling = role.includes("YKK");
  const evaluator = role.includes("Degerlendirici");
  if (kurum) {
    usr.role = "organisation";
  } else if (teamLeader) {
    usr.role = "teamLeader";
  } else if (editor) {
    usr.role = "editor";
  } else if (consistency) {
    usr.role = "consistency";
  } else if (spelling) {
    usr.role = "spelling";
  } else if (evaluator) {
    usr.role = "evaluator";
  } */

  const admin = role.includes("admin");
  const kurum = role.includes("Kurum");
  const teamLeader = role.includes("TB");
  const editor = role.includes("Editor");
  const consistency = role.includes("TKK");
  const spelling = role.includes("YKK");
  const evaluator = role.includes("Degerlendirici");
  const student = role.includes("Öğrenci");
  const watcher = role.includes("Gözlemci");

  if (kurum) {
    usr.role = "organisation";
  } else if (teamLeader) {
    usr.role = "teamLeader";
  } else if (editor) {
    usr.role = "editor";
  } else if (consistency) {
    usr.role = "consistency";
  } else if (spelling) {
    usr.role = "spelling";
  } else if (evaluator) {
    usr.role = "evaluator";
  } else if (admin) {
    usr.role = "admin";
  } else if (student) {
    usr.role = "student";
  } else if (watcher) {
    usr.role = "watcher";
  }

  //Herkeste Admin Rolü Var Sıkıntı Orada

  const newItems1 = items.filter(
    (item, index) => usr?.role === item.role || item.role == "everyone"
  );

  let newElementArray = [];
  useEffect(() => {
    loadActivities();
    setNewItems(newItems1);
  }, []);
  useEffect(() => {
    if (isShow) {
      newItems1.map((element) =>
        element.show == "true"
          ? newElementArray.push(element)
          : isShow == true && newElementArray.push(element)
      );
      setNewItems(newElementArray);
    } else {
      newItems1.map(
        (element) => element.show != "false" && newElementArray.push(element)
      );
      setNewItems(newElementArray);
    }
  }, [isShow]);

  const location = useLocation();
  const navLink = (name, icon, badge) => {
    return (
      <>
        {icon && icon}
        {name && name}
        {badge && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}
      </>
    );
  };

  const navItem = (item, index) => {
    const { component, name, badge, icon, ...rest } = item;
    const Component = component;
    return (
      <Component
        {...(rest.to &&
          !rest.items && {
            component: NavLink,
            //activeClassName: 'active',
          })}
        key={index}
        {...rest}
      >
        {navLink(name, icon, badge)}
      </Component>
    );
  };
  const navGroup = (item, index) => {
    const { component, name, icon, to, ...rest } = item;
    const Component = component;
    return (
      <>
        <Component
          idx={String(index)}
          key={index}
          toggler={navLink(name, icon)}
          visible={location.pathname.startsWith(to)}
          {...rest}
        >
          {item.items?.map((item, index) =>
            item.items ? navGroup(item, index) : navItem(item, index)
          )}
        </Component>
      </>
    );
  };

  return (
    <React.Fragment>
      {newItems &&
        newItems
          .filter(
            (item) =>
              !role.includes("Kurum") ||
              item.name !== "ÖDR Değerlendirme Şablonu"
          )
          .map((item, index) =>
            item.items ? navGroup(item, index) : navItem(item, index)
          )}
    </React.Fragment>
  );
};

AppSidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
};
